import { Component, OnInit, ElementRef, Output , EventEmitter } from '@angular/core';
import { ROUTES } from '../sidebar/sidebar.component';
import { Location} from '@angular/common';
import { Router } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { IAppState } from 'src/app/store/state/app.state';
import { selectSelectedUser } from '../../../app/store/selectors/login.selector';
import {Account} from 'src/app/services/models/account/account.model';
import { AuthService } from 'src/app/services/auth.service';
import { ToastrService } from 'ngx-toastr';
import { ResponseType } from 'src/app/enums/response-type.enum';

import { LoginUsersSuccess } from 'src/app/store/actions/login.actions';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html'
})
export class NavbarComponent implements OnInit {
  @Output() toggleEvent = new EventEmitter();
  public focus;
  public loginUser:Account;
  public listTitles: any[];
  public location: Location;
  constructor(location: Location,  
    private element: ElementRef, 
    private router: Router,
    private _store: Store<IAppState>,
    private toastr: ToastrService,
    private authService: AuthService) {
    this.location = location;
    this.loginUser = new Account();
  }

  ngOnInit() {
    this.listTitles = ROUTES.filter(listTitle => listTitle);
    this._store.pipe(select(selectSelectedUser)).subscribe(result=>{
      if(result !== null && result  !== undefined)
      {
        this.loginUser = result;
      }
    });
  }

  logout(){
    //call api
    this.authService.logout().subscribe(result => {
      this.toastr.success('Bạn đã đăng xuất khỏi phiên làm việc', 'Đăng xuất thành công');
      this.goToLoginPage();
    }, error => console.error(error));
  }

  getTitle(){
    return ""
    var titlee = this.location.prepareExternalUrl(this.location.path());
    if(titlee.charAt(0) === '#'){
        titlee = titlee.slice( 2 );
    }
    for(var item = 0; item < this.listTitles.length; item++){
        if(this.listTitles[item].path === titlee){
            return this.listTitles[item].title;
        }
    }
    return 'Home';
  }
  goToLoginPage() {
    this._store.dispatch(new LoginUsersSuccess(null));
    this.router.navigate(['login']);
  }

  toggeClick(){
    this.toggleEvent.emit(null);
  }
}
